var exports = {
  "wx": "GuildHeaderBottomSheet.module__header___V0NwcH",
  "R3": "GuildHeaderBottomSheet.module__avatarWrapper___V0NwcH",
  "Kk": "GuildHeaderBottomSheet.module__icon___V0NwcH",
  "Qq": "GuildHeaderBottomSheet.module__text___V0NwcH",
  "DD": "GuildHeaderBottomSheet.module__title___V0NwcH",
  "M1": "GuildHeaderBottomSheet.module__stats___V0NwcH",
  "dJ": "GuildHeaderBottomSheet.module__stat___V0NwcH",
  "gW": "GuildHeaderBottomSheet.module__statDot___V0NwcH",
  "rR": "GuildHeaderBottomSheet.module__statDotOnline___V0NwcH",
  "rb": "GuildHeaderBottomSheet.module__statDotMembers___V0NwcH",
  "KA": "GuildHeaderBottomSheet.module__statText___V0NwcH",
};

module.exports = exports;
